import { subscribe } from '../libs/pubsubs'
import { PUB_SUB_EVENTS } from '../libs/constans'

export class QuantityInput extends HTMLElement {
  constructor() {
    super()
    this.input = this.querySelector('input')
    this.changeEvent = new Event('change', { bubbles: true })
    this.input.addEventListener('change', this.onInputChange.bind(this))
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    )
  }

  quantityUpdateUnsubscriber = undefined

  connectedCallback() {
    this.validateQtyRules()
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    )
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber()
    }
  }

  onInputChange(event) {
    this.validateQtyRules()
  }

  onButtonClick(event) {
    event.preventDefault()
    const previousValue = this.input.value

    //Cambio agregado para que funcione con el quantity fixed
    let otherInput = null
    let otherInputPrevious = null

    console.log(event.target.name)
    // Para el caso de que exista el fixed

    if (this.input.id === 'Quantity-Fixed') {
      otherInput = document.querySelector('input[id^="Quantity-"]')
      otherInputPrevious = otherInput.value
    }

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown()

    // Para el caso de que exista el fixed
    if (event.target.name === 'plus' && otherInput) {
      otherInput.stepUp()
    } else if (event.target.name === 'minus' && otherInput) {
      otherInput.stepDown()
    }

    if (otherInput) {
      if (otherInputPrevious !== otherInput.value)
        otherInput.dispatchEvent(this.changeEvent)
    }

    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent)
  }

  validateQtyRules() {
    const value = parseInt(this.input.value)
    if (this.input.min) {
      const min = parseInt(this.input.min)
      const buttonMinus = this.querySelector(".quantity__button[name='minus']")
      buttonMinus.classList.toggle('disabled', value <= min)
    }
    if (this.input.max) {
      const max = parseInt(this.input.max)
      const buttonPlus = this.querySelector(".quantity__button[name='plus']")
      buttonPlus.classList.toggle('disabled', value >= max)
    }
  }
}
